import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import Login from './pages/Login/Login';
import ForgotPassword from './pages/Login/ForgotPassword';
import ForgotPasswordSuccess from './pages/Login/ForgotPasswordSuccess';

import AdminRegistry from './pages/AdminRegistry/AdminRegistry';
import CreateAdmin from './pages/AdminRegistry/CreateAdmin';
import UpdateAdmin from './pages/AdminRegistry/UpdateAdmin';

import MembersRegistry from './pages/MembersRegistry/MembersRegistry';
import CreateMember from './pages/MembersRegistry/CreateMember';
import UpdateMember from './pages/MembersRegistry/UpdateMember';
import ViewMember from './pages/MembersRegistry/ViewMember';

import LoanManagement from './pages/Loan/LoanManagement';
import CreateLoan from './pages/Loan/CreateLoan';
import LoanStatusDetailsPage from './pages/Loan/LoanStatusDetailsPage';
import BorrowerDetails from './pages/Loan/BorrowerDetails';
import AdminPreviewLoanApplicationForm from './pages/Loan/PreviewLoanApplicationForm';

import HomePage from './pages/Home/HomePage';
import PageNotFound from './pages/Home/PageNotFound';
import TermsPage from './pages/Home/Terms';

import MemberLogin from './pages/MembersPortal/Login/Login';
import MemberForgotPassword from './pages/MembersPortal/Login/ForgotPassword';
import MemberForgotPasswordSuccess from './pages/MembersPortal/Login/ForgotPasswordSuccess';
import Dashboard from './pages/Dashboard/Dashboard';
import MemberDetailsPage from './pages/MembersPortal/MemberDetails/MemberDetailsPage';
import MemberChangePassword from './pages/MembersPortal/ChangePassword/ChangePasswordPage';
import MemberBorrowerLoanDetailsPage from './pages/MembersPortal/Loan/BorrowerLoanDetailsPage';
import MemberLoanStatusDetailsPage from './pages/MembersPortal/Loan/LoanStatusDetailsPage';
import MemberCreateLoanPage from './pages/MembersPortal/Loan/CreateLoanPage';
import PreviewLoanApplicationForm from './pages/MembersPortal/Loan/PreviewLoanApplicationForm';
import PaymentPage from './pages/MembersPortal/MemberDetails/Payment';
import Events from './pages/Home/Events';


import ImportPage from './pages/Import/ImportPage';


function App() {
  const location = window.location.href;
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/Terms" element={<TermsPage />} />
        <Route path="/PrivacyPolicy" element={<TermsPage />} />
        <Route path="/Activity/:eventID" element={<Events />} />

        <Route path="/Admin/" element={<Login />} />
        <Route path="/Admin/Dashboard" element={<Dashboard />} />
        <Route path="/Admin/Login" index element={<Login />} />
        <Route path="/Admin/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/Admin/ForgotPasswordSuccess" element={<ForgotPasswordSuccess />} />


        {/* Admin Registry Module */}
        <Route path="/Admin/AdminRegistry" element={<AdminRegistry />} />
        <Route path="/Admin/CreateAdmin" element={<CreateAdmin />} />
        <Route path="/Admin/UpdateAdmin/:username" element={<UpdateAdmin />} />


        {/* Members Registry Module */}
        <Route path="/Admin/MembersRegistry" element={<MembersRegistry />} />
        <Route path="/Admin/CreateMember" element={<CreateMember />} />
        <Route path="/Admin/UpdateMember/:memberId" element={<UpdateMember />} />
        <Route path="/Admin/ViewMember/:memberId" element={<ViewMember />} />

        {/* Loan Management Module */}
        <Route path="/Admin/LoanManagement" element={<LoanManagement />} />
        <Route path="/Admin/CreateLoan/:memberId" element={<CreateLoan />} />
        <Route path="/Admin/LoanStatusDetails/:loanId" element={<LoanStatusDetailsPage />} />
        <Route path="/Admin/BorrowerDetails/:memberId" element={<BorrowerDetails />} />
        <Route path="/Admin/PreviewLoanApplicationForm/:loanId" element={<AdminPreviewLoanApplicationForm />} />

        {/* Import Page */}
        <Route path="/Admin/ImportPage" element={<ImportPage />} />

        {/* Members Portal */}
        <Route path="/Members" element={<MemberLogin />} />
        <Route path="/Members/Login" element={<MemberLogin />} />
        <Route path="/Members/MemberDetails" element={<MemberDetailsPage />} />
        <Route path="/Members/MemberForgotPassword" element={<MemberForgotPassword />} />
        <Route path="/Members/MemberForgotPasswordSuccess" element={<MemberForgotPasswordSuccess />} />
        <Route path="/Members/MemberChangePassword" element={<MemberChangePassword />} />
        <Route path="/Members/BorrowerDetails" element={<MemberBorrowerLoanDetailsPage />} />
        <Route path="/Members/LoanStatusDetails/:loanId" element={<MemberLoanStatusDetailsPage />} />
        <Route path="/Members/Payment/:loanId" element={<PaymentPage />} />
        <Route path="/Members/CreateLoan" element={<MemberCreateLoanPage />} />
        <Route path="/Members/PreviewLoanApplicationForm/:loanId" element={<PreviewLoanApplicationForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
